import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { Menu, Tooltip, Typography } from "antd";
import React from "react";
import useDeviceDetect from "../hooks/useDeviceDetect";
import { userHasLevel } from "./index";
import { useSelector } from "react-redux";
import { t } from "i18next";

export const visibilityOnRoute = ({
  child,
  prestation,
  id,
  dangerousUpdate,
}) => {
  if (child.visibility !== undefined) {
    if (child.visibility.status) {
      if (dangerousUpdate) {
        return false;
      } else {
        // if (location?.state?.force !== undefined) {
        //   // force render throu ther navigate duplicate
        //   return !location?.state?.force
        // } else {
        return !child.visibility.status.includes(prestation.status);

        // }
      }
    }
  } else {
    return false;
  }
};

export const isRouteDisabled = ({ child, prestation, id }) => {
  if (child.disabled) {
    if (child.disabled.step) {
      return prestation.steps[child.disabled.step] === false;
    }

    if (child.disabled.onNew) {
      return child.disabled.onNew === (id === "new");
    }
  } else {
    return false;
  }

  if (id === "new" && child?.disabledOnNew !== undefined) {
    return child.disabledOnNew;
  } else if (child?.step) {
    return prestation.steps[child?.step] === false;
  } else {
    return false;
  }
};

export const convertedChildrenToNav = (nav, loading) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { prestation, dangerousUpdate } = useSelector(
    state => state.prestation,
  );

  return nav.children
    .filter(route => userHasLevel(route))
    .filter(
      child => !visibilityOnRoute({ child, prestation, id, dangerousUpdate }),
    )
    .map(child => {
      return {
        disabled: isRouteDisabled({ child, id, prestation, dangerousUpdate }),
        key: child.path,
        label: <RenderTitle title={child.title} />,
        onClick: () => {
          if (!visibilityOnRoute({ child, id, prestation, dangerousUpdate })) {
            navigate(child.path);
          }
        },
      };
    });
};

function trimString(str, number) {
  const maxLength = number;

  if (str.length > maxLength) {
    return str.substring(0, maxLength - 3) + "...";
  }

  return str;
}

export const renderTitle = ({ title, trim = false }) => {
  const { id } = useParams();
  const { prestation, loading, ready, dangerousUpdate } = useSelector(
    state => state.prestation,
  );

  const { status } = prestation;

  const titleLong =
    typeof title === "function"
      ? title({ id, status, dangerousUpdate })
      : title;
  let titleSmall = "";
  if (trim !== false) {
    titleSmall = trimString(titleLong, trim);
  }

  return trim ? titleSmall : titleLong;
};

export const RenderTitle = ({ title, trim = false }) => {
  const { id } = useParams();
  const { prestation, loading, ready, dangerousUpdate } = useSelector(
    state => state.prestation,
  );

  const { status } = prestation;

  const titleLong =
    typeof title === "function"
      ? title({ id, status, dangerousUpdate })
      : title;
  let titleSmall = "";
  if (trim !== false) {
    titleSmall = trimString(titleLong, trim);
  }

  return trim ? (
    <Tooltip placement="topLeft" title={titleLong}>
      {titleSmall}
    </Tooltip>
  ) : (
    titleLong
  );
};

export const RenderMenuSider = ({ menu, extra = null, loading = false }) => {
  const { isMobile } = useDeviceDetect();

  return (
    <div
      style={{
        background: isMobile ? "white" : "transparent",
        paddingTop: isMobile ? 15 : 0,
      }}
    >
      {extra !== null && (!isMobile ? extra : null)}
      <Typography.Title
        level={4}
        style={{
          textAlign: isMobile ? "center" : "left",
          display: "flex",
          justifyContent: isMobile ? "center" : "flex-start",
          alignItems: isMobile ? "center" : "flex-start",
          gap: "10px",
        }}
      >
        {menu.title}
        {isMobile ? extra : null}
      </Typography.Title>
      <div
        style={
          isMobile
            ? { overflowX: "scroll" }
            : { flex: 1, justifyContent: "end", display: "flex" }
        }
      >
        <Menu
          inlineIndent={10}
          inlineCollapsed={false}
          loading={loading}
          selectedKeys={[location.pathname]}
          mode={isMobile ? "horizontal" : "inline"}
          items={convertedChildrenToNav(menu, loading)}
          overflowedIndicator={false}
          className={isMobile ? "custom-menu-mobile" : "custom-menu"}
        ></Menu>
      </div>
    </div>
  );
};

export const NavLinkCustom = ({ route }) => {
  if (userHasLevel(route)) {
    return (
      <NavLink
        to={route.path}
        style={({ isActive, isPending }) => {
          return {
            //color: isActive ? 'red' : 'inherit',
          };
        }}
        className={({ isActive, isPending }) => {
          return isActive ? "active menuLink" : "menuLink ";
        }}
      >
        {route.title}
      </NavLink>
    );
  } else {
    return null;
  }
};

export const renderDetailEntityTitlePrestation = () => {
  const {
    prestation: { reference },
    loading,
  } = useSelector(state => state.prestation);

  return `${t("prestation")} ${reference}`;
};
